import React, { Component, Fragment } from "react";
import AppContext from "../../contexts/AppContext";
import { resendActivationEmail } from "../../services/user";

class Alert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alerts: {
                email: false,
                aproved: false,
                failed: false,
                review: false,
                completed: false,
                quiz: false
            }
        };
    }

    handleResend = () => {
        resendActivationEmail({ email: this.context.state.user.email })
            .then(res => {
                this.context.state.showCodeMessage(
                    "We sent your activation email again!",
                    "success"
                );
            })
            .catch(err => {
                this.context.state.showCodeMessage(
                    "failed to send activation email again!",
                    "danger"
                );
            });
    };

    hideAlert = (type, days) => {
        let temp = this.state.alerts;
        temp[type] = false;
        temp[type + "_end"] =
            Math.floor(Date.now() / 1000) + Math.floor(days * 24 * 3600);

        this.setState({ alerts: temp });
        localStorage.setItem("alerts", JSON.stringify(temp));
    };

    componentDidMount = () => {
        let temp = JSON.parse(localStorage.getItem("alerts"));
        // if (temp) {
        //     for (var key in temp) {
        //         if (temp.hasOwnProperty(key)) {
        //             if (key.lastIndexOf("_end") >= 0) {
        //                 if (temp[key] <= Math.floor(Date.now() / 1000)) {
        //                     temp[key.split("_")[0]] = true;
        //                 }
        //             }
        //         }
        //     }
        //     this.setState({ alerts: temp });
        // }
    };
    render() {
        return (
            <Fragment>
                <div className="alert-box">
                    {this.context.state.user.state === "aproved" &&
                    this.state.alerts.aproved === true ? (
                        <div
                            className="alert alert-wight alert-success  alert-dismissible fade show my-2"
                            role="alert"
                        >
                            <button
                                onClick={e => {
                                    this.hideAlert("approved", "9999");
                                }}
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong className="text-uppercase">
                                Account status
                            </strong>
                            <br></br>
                            Your account has been approved! Your portfolio is
                            now live.
                            <br></br>
                            <a text-white href="/pw/">
                                {" "}
                                VIEW.
                            </a>
                        </div>
                    ) : null}
                    {this.context.state.user.quiz === "failed" &&
                    this.state.alerts.failed === true ? (
                        <div
                            className="alert alert-wight alert-danger  alert-dismissible fade show my-2"
                            role="alert"
                        >
                            <button
                                onClick={e => {
                                    this.hideAlert("failed", "1");
                                }}
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong className="text-uppercase">
                                Account status
                            </strong>
                            <br></br>
                            Your account was unfortunately denied. You can
                            re-apply in{" "}
                            {this.context.state.user.quiz_details.days} days.
                        </div>
                    ) : null}
                    {this.context.state.user.state === "review" &&
                    this.state.alerts.review === true ? (
                        <div
                            className="alert alert-wight alert-info  alert-dismissible fade show my-2"
                            role="alert"
                        >
                            <button
                                onClick={e => {
                                    this.hideAlert("review", "1");
                                }}
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong className="text-uppercase">
                                Account status
                            </strong>
                            <br></br>
                            Your account is being re-apply for approval.
                        </div>
                    ) : null}

                    {this.context.state.user.state === "completed" &&
                    this.state.alerts.completed === true ? (
                        <div
                            className="alert alert-wight alert-warning  alert-dismissible fade show my-2"
                            role="alert"
                        >
                            <button
                                onClick={e => {
                                    this.hideAlert("completed", "1");
                                }}
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong className="text-uppercase">
                                Account status
                            </strong>
                            <br></br>
                            All required steps were completed. Your account is
                            now under review for verification.
                        </div>
                    ) : null}

                    {this.context.state.user.quiz === "ready" &&
                    this.state.alerts.quiz === true ? (
                        <div
                            className="alert alert-wight alert-warning  alert-dismissible fade show my-2"
                            role="alert"
                        >
                            <button
                                onClick={e => {
                                    this.hideAlert("quiz", "1");
                                }}
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong className="text-uppercase">
                                Quiz Verification
                            </strong>
                            <br></br>
                            take the quiz to verify your your account
                            <br></br>
                            <a href="/writer/quiz" target="_blank">
                                TAKE QUIZ
                            </a>
                        </div>
                    ) : null}

                    {this.context.state.user.email_verified !== true &&
                    this.state.alerts.email === true ? (
                        <div
                            className="alert alert-wight alert-warning  alert-dismissible fade show my-2"
                            role="alert"
                        >
                            <button
                                onClick={e => {
                                    this.hideAlert("email", "1");
                                }}
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <strong className="text-uppercase">
                                Email verification
                            </strong>
                            <br></br>
                            Verify your email address using the email sent to
                            your inbox
                            <br></br>
                            <a onClick={this.handleResend}>RESEND EMAIL</a>
                        </div>
                    ) : null}
                </div>
            </Fragment>
        );
    }
}
Alert.contextType = AppContext;
export default Alert;



// WEBPACK FOOTER //
// ./src/components/writer/Alert.js